<template>
  <section class="avatars-group stacked" style="overflow:visible">
    <div
      :key="avatar.id"
      v-for="avatar in avatarsStackedLimited"
      class="avatars-group__item"
    >
      <user-avatar :user-detail="avatar"></user-avatar>
    </div>
    <div v-if="total > stackedLimit" class="avatars-group__item mt-1">
      <v-avatar @click.stop="$router.push({name: 'app-settings-members', params: {app_id: appId}})" class="grey" size="30">
        <span class="font-weight-light text-caption pointer"> +{{ total - stackedLimit }} </span>
      </v-avatar>
    </div>
    <!-- <v-avatar
      v-if="total - avatarsSorted.length"
      size="30"
      class="primary"
    >
      <span class="bold-text white--text"> +{{ total - avatarsSorted.length }} </span>
    </v-avatar> -->
    <!-- <div class="avatars-group__item more">
      <v-menu
        transition="slide-y-transition"
        v-model="stackedMenu"
        left
        :max-height="menuMaxHeight"
        nudge-bottom="8"
        offset-y
      >
        <template
          #activator="{ attrs, on }"
          v-if="total - avatarsSorted.length"
        >
          <v-btn small icon class="primary" dark v-bind="attrs" v-on="on">
            +{{ total - avatarsSorted.length }}
          </v-btn>
        </template>
        <v-list dense class="pa-2">
          <v-list-item
            class="px-0"
            v-for="(avatar, i) in avatarsSorted"
            :key="i"
          >
            <profile-avatar size="30" :avatar="avatar" />
            <v-list-item-title class="pl-2" v-text="avatar.name" />
          </v-list-item>
        </v-list>
      </v-menu>
    </div> -->
  </section>
</template>

<script>
import UserAvatar from "@/view/components/Common/UserAvatar";
export default {
  components: {
    UserAvatar,
  },
  props: {
    appId: {
      type: String,
      required: true
    },
    data: {
      type: [Array, Object],
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      menuMaxHeight: `${60 * 5 + 4}px`,
      stackedLimit: 5,
      stackedMenu: false,
    };
  },
  computed: {
    avatarsSorted() {
      let data = this.data;
      return data && data.length && data.length > 0
        ? data.sort((a, b) => a.name.localeCompare(b.name))
        : null;
    },
    avatarsStackedLimited() {
      return this.avatarsSorted && this.avatarsSorted.length > 0
        ? this.avatarsSorted.slice(0, this.stackedLimit)
        : null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
